'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@achra/ui/table';
import { ArrowUpDown } from 'lucide-react';
import SimpleBar from 'simplebar-react';
import type { BudgetStatement, MetricWithoutBudget } from '@/modules/finances/types';
import { SortEnum } from '@/modules/shared/types/common-enums';
import { useBudgetStatementTable } from '../budget-statement-item/use-budget-statement-table';
import { BudgetStatementTableItem } from './budget-statement-table-item';
export interface BudgetStatementTableProps {
  budgetStatements: BudgetStatement[];
  budgetMetric: MetricWithoutBudget;
  className?: string;
  asSectionContent?: boolean;
}
function BudgetStatementTable(t0) {
  const $ = _c(58);
  const {
    budgetStatements,
    budgetMetric,
    className,
    asSectionContent: t1
  } = t0;
  const asSectionContent = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== asSectionContent || $[1] !== budgetMetric || $[2] !== budgetStatements) {
    t2 = {
      budgetStatements,
      budgetMetric,
      asSectionContent
    };
    $[0] = asSectionContent;
    $[1] = budgetMetric;
    $[2] = budgetStatements;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    headersSort,
    sortedBudgetStatements,
    proccesedBudgetStatementsTableColumns,
    handleSortClickHeader,
    simpleBarRef,
    cardContentRef,
    itemsWrapperRef
  } = useBudgetStatementTable(t2);
  let t3;
  if ($[4] !== className) {
    t3 = cn("w-full", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = asSectionContent && "px-2";
  let t5;
  if ($[6] !== t4) {
    t5 = cn("[&_table]:block [&_table]:w-full", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = !asSectionContent && "border-b-0!";
  let t7;
  if ($[8] !== t6) {
    t7 = cn("mb-2 inline-block w-full", t6);
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = !asSectionContent && "bg-accent! flex h-fit w-full justify-between rounded-none! rounded-tl-xl! rounded-tr-xl! border-none! py-4 shadow-sm! outline-none! xl:py-4 2xl:py-4";
  const t9 = asSectionContent && "flex h-fit w-full border-b-0! py-4";
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = cn(t8, t9);
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== handleSortClickHeader || $[14] !== headersSort || $[15] !== proccesedBudgetStatementsTableColumns) {
    let t12;
    if ($[17] !== handleSortClickHeader || $[18] !== headersSort) {
      t12 = (column, index) => <TableHead key={column.accessorKey} className={cn("inline-block h-fit p-0!", column.isNumeric && "text-right", index === 0 && "w-[27%] pl-4!", index === 1 && "w-[17%]", index === 2 && "w-[15%]", index === 3 && "w-[14%]", index === 4 && "flex-1")}><Button variant="ghost" aria-label={`Sort ${column.header} column`} onClick={() => {
          handleSortClickHeader(index);
        }} className={cn("[&_path]:stroke-foreground/30 hover:[&_path]:stroke-foreground/50 active:[&_path]:stroke-foreground! h-fit p-0! font-semibold hover:bg-transparent lg:text-base/6 dark:hover:bg-transparent", headersSort[index] === SortEnum.Asc && "[&_path:nth-child(3)]:stroke-foreground [&_path:nth-child(4)]:stroke-foreground hover:[&_path:nth-child(3)]:stroke-foreground/50 hover:[&_path:nth-child(4)]:stroke-foreground/50 hover:[&_path:nth-child(1)]:stroke-foreground/30 hover:[&_path:nth-child(2)]:stroke-foreground/30", headersSort[index] === SortEnum.Desc && "[&_path:nth-child(1)]:stroke-foreground [&_path:nth-child(2)]:stroke-foreground hover:[&_path:nth-child(1)]:stroke-foreground/50 hover:[&_path:nth-child(2)]:stroke-foreground/50 hover:[&_path:nth-child(3)]:stroke-foreground/30 hover:[&_path:nth-child(4)]:stroke-foreground/30")}>{column.header}{column.hasSort && <ArrowUpDown className="size-4" />}</Button></TableHead>;
      $[17] = handleSortClickHeader;
      $[18] = headersSort;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    t11 = proccesedBudgetStatementsTableColumns.map(t12);
    $[13] = handleSortClickHeader;
    $[14] = headersSort;
    $[15] = proccesedBudgetStatementsTableColumns;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <TableHead className="h-fit w-[10%] p-0! text-right" />;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t11) {
    t13 = <TableRow className={t10}>{t11}{t12}</TableRow>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t7) {
    t14 = <TableHeader className={t7}>{t13}</TableHeader>;
    $[24] = t13;
    $[25] = t7;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t5) {
    t15 = <Table variant="pills" className={t5}>{t14}</Table>;
    $[27] = t14;
    $[28] = t5;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  const t16 = !asSectionContent && "-mx-2 px-2 pb-3";
  let t17;
  if ($[30] !== t16) {
    t17 = cn(t16);
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = asSectionContent && "px-2 pb-2";
  let t19;
  if ($[32] !== t18) {
    t19 = cn(t18);
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== asSectionContent || $[35] !== budgetMetric || $[36] !== sortedBudgetStatements) {
    let t21;
    if ($[38] !== asSectionContent || $[39] !== budgetMetric) {
      t21 = budgetStatement => <BudgetStatementTableItem key={budgetStatement.id} budgetStatement={budgetStatement} budgetMetric={budgetMetric} className={cn("flex h-15.5! w-full cursor-pointer items-center border-b-0!", !asSectionContent && "justify-between rounded-none! shadow-sm! last:rounded-b-xl!")} />;
      $[38] = asSectionContent;
      $[39] = budgetMetric;
      $[40] = t21;
    } else {
      t21 = $[40];
    }
    t20 = sortedBudgetStatements.map(t21);
    $[34] = asSectionContent;
    $[35] = budgetMetric;
    $[36] = sortedBudgetStatements;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[41] !== t20) {
    t21 = <Table variant="pills" className="[&_table]:block [&_table]:w-full"><TableBody className="flex flex-col gap-2">{t20}</TableBody></Table>;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== itemsWrapperRef || $[44] !== t19 || $[45] !== t21) {
    t22 = <div ref={itemsWrapperRef} className={t19}>{t21}</div>;
    $[43] = itemsWrapperRef;
    $[44] = t19;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== simpleBarRef || $[48] !== t17 || $[49] !== t22) {
    t23 = <SimpleBar ref={simpleBarRef} className={t17} autoHide={false}>{t22}</SimpleBar>;
    $[47] = simpleBarRef;
    $[48] = t17;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== cardContentRef || $[52] !== t23) {
    t24 = <div ref={cardContentRef}>{t23}</div>;
    $[51] = cardContentRef;
    $[52] = t23;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t15 || $[55] !== t24 || $[56] !== t3) {
    t25 = <div className={t3}>{t15}{t24}</div>;
    $[54] = t15;
    $[55] = t24;
    $[56] = t3;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  return t25;
}
export { BudgetStatementTable };